import React from 'react';
import AsideMenuItem from './AsideMenuItem';

function PublicAsideMenu() {
    return (
        <aside>
            <div id="menu-list">
                <AsideMenuItem label="Home" icon={<i className="fas fa-home"></i>} to="/home" />
                <AsideMenuItem label="Pay Fees" icon={<i className="fas fa-credit-card"></i>} to="/payFees" />
                <AsideMenuItem label="History" icon={<i className="fas fa-file-invoice-dollar"></i>} to="/history" />
                <AsideMenuItem label="Link Accounts" icon={<i className="fas fa-link"></i>} to="/linkAccounts" />
            </div>
        </aside>
    );
}

export default PublicAsideMenu;